"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounceFunction = void 0;
exports.useDidUpdateEffect = useDidUpdateEffect;
var _react = require("react");
function useDidUpdateEffect(func, inputs) {
  var didMountRef = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    if (didMountRef.current) func();else didMountRef.current = true;
  }, inputs);
}
var debounceFunction = function debounceFunction(func, delay) {
  var timer;
  return function () {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(function () {
      func.apply(_this, [].concat(args));
    }, delay);
  };
};
exports.debounceFunction = debounceFunction;